export const reasons = (state) => state.reasons
export const reasonTypes = (state) => state.reasonTypes
